module.exports = __webpack_public_path__ + "assets/img/pp.45c98774.jpg";